import { gql, TypedDocumentNode } from '@apollo/client';
import {
  BillingContractType,
  BillingEventType,
  BillingProfile,
  ProfileSite,
  TabsCustomer,
} from './billing-manager-types';

export const BillingProfileCoverageQuery: TypedDocumentNode<{ adminBillingProfileCoverageQuery: ProfileSite[] }> = gql`
  query adminBillingProfileCoverageQuery {
    adminBillingProfileCoverageQuery {
      _id
      siteName
      createdAt
      billingProfileName
      billingProfileId
    }
  }
`;

export const BillingProfileBySiteIdQuery: TypedDocumentNode<{ adminBillingProfileQuery: BillingProfile }> = gql`
  query adminBillingProfileQuery($sellerSiteId: String!) {
    adminBillingProfileQuery(sellerSiteId: $sellerSiteId) {
      id
      name
      orgSiteIds
      tabsCustomerId
      saasEventId
      mmEventId
    }
  }
`;

export const BillingCustomersListQuery: TypedDocumentNode<{ adminBillingCustomerListQuery: TabsCustomer[] }> = gql`
  query adminBillingCustomerListQuery {
    adminBillingCustomerListQuery {
      id
      customerName
      hubspotId
      hasContract
    }
  }
`;

export const BillingEventTypeListQuery: TypedDocumentNode<{ adminBillingEventTypeListQuery: BillingEventType[] }> = gql`
  query adminBillingEventTypeListQuery {
    adminBillingEventTypeListQuery {
      id
      name
    }
  }
`;

export const BillingContractsListQuery: TypedDocumentNode<
  { adminContractListQuery: BillingContractType[] },
  { customerId: string }
> = gql`
  query adminContractListQuery($customerId: String!) {
    adminContractListQuery(customerId: $customerId) {
      id
      commitmentId
      scheduleId
      obligationId
      customerName
      contractDocName
      status
      serviceStartDate
      serviceEndDate
      hubspotId
      revenue {
        timeframe
        total
        booksClosed
      }
      hasSentInvoices
    }
  }
`;

export const TabsConnectionAuditQuery: TypedDocumentNode<{
  adminTabsConnectionAuditQuery: { _id: string; errors: string[] }[];
}> = gql`
  query adminTabsConnectionAuditQuery {
    adminTabsConnectionAuditQuery {
      _id
      errors
    }
  }
`;

export const SaveBillingProfile: TypedDocumentNode<
  { saveBillingProfile: { profile: BillingProfile; errors: string[] } },
  BillingProfile
> = gql`
  mutation saveBillingProfile($id: String, $name: String!, $orgSiteIds: [String]!, $tabsCustomerId: String!, $saasEventId: String, $mmEventId: String) {
    saveBillingProfile(id: $id, name: $name, orgSiteIds: $orgSiteIds, tabsCustomerId: $tabsCustomerId, saasEventId: $saasEventId, mmEventId: $mmEventId) {
      profile {
        id
        name
        orgSiteIds
        tabsCustomerId
        saasEventId
        mmEventId
      }
      errors
    }
  }
`;

export const UpdateBillingSchedule: TypedDocumentNode<
  { updateBillingSchedule: { contract: BillingContractType; errors: string[] } },
  {
    contractId: string;
    commitmentId: string;
    scheduleId: string;
    obligationId: string;
    serviceStartDate: string;
  }
> = gql`
  mutation updateBillingSchedule($contractId: String!, $commitmentId: String!, $scheduleId: String!, $obligationId: String, $serviceStartDate: String!) {
    updateBillingSchedule(contractId: $contractId, commitmentId: $commitmentId, scheduleId: $scheduleId, obligationId: $obligationId, serviceStartDate: $serviceStartDate) {
      contract {
        id
        commitmentId
        scheduleId
        customerName
        contractDocName
        status
        serviceStartDate
        serviceEndDate
        hubspotId
        revenue {
          timeframe
          total
          booksClosed
        }
        hasSentInvoices
      }
      errors
    }
  }
`;
